import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import Select from 'react-select';

const AddClient = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name:'',
    userId: '',
    referredBy: '',
    brokerReferrel: '',
    commissionRate: '',
    idPercentage: '',
  });

  const [allEmployees, setAllEmployees] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [brokerOptions, setBrokerOptions] = useState([]);

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const res = await axios.get('https://api.happychd.com/api/employees');
        setAllEmployees(res.data);
      } catch (err) {
        console.error('Error loading employees', err);
      }
    };
    const fetchBrokers = async () => {
      try {
        const res = await axios.get('https://api.happychd.com/api/broker');
        const options = res.data.map(emp => ({
          value: emp._id,
          label: `${emp.userId}`
        }));
        setBrokerOptions(options);
      } catch (err) {
        console.error('Error loading employees', err);
      }
    };

    fetchBrokers();
    fetchEmployees();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSelectChange = (selectedOption) => {
    setFormData(prev => ({ ...prev, brokerReferrel: selectedOption?.value || '' }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage('');
    setErrorMessage('');

    try {
      let referredById = '';

      if (formData.referredBy.trim()) {
        const existing = allEmployees.find(emp => emp.userId === formData.referredBy.trim());

        if (existing) {
          referredById = existing._id;
        } else {
          // Create new employee
          const addEmpRes = await axios.post('https://api.happychd.com/api/employees', {
            userId: formData.referredBy.trim(),
            password: formData.referredBy.trim(),
          });
          referredById = addEmpRes.data._id || addEmpRes.data.employee?._id;
        }
      }

      // Create new client
      const response = await axios.post('https://api.happychd.com/api/user', {
        name: formData.name,
        userId: formData.userId,
        referredBy: referredById,
        brokerReferrel:  formData.brokerReferrel,
        commission: parseFloat(formData.commissionRate) || 0,
        idPercentage: parseFloat(formData.idPercentage),
      });

      const newUser = response.data.user;

      // Update employee with this referral (optional)
      if (referredById) {
        await axios.patch(`https://api.happychd.com/api/employees/${referredById}`, {
          referredUserId: newUser._id,
          model: "User"
        });
      }

      setSuccessMessage(`User ${newUser.userId} created successfully.`);
      setFormData({
        name:'',
        userId: '',
        referredBy: '',
        brokerReferrel: '',
        commissionRate: '',
        idPercentage: ''
      });

    } catch (err) {
      setErrorMessage(err.response?.data?.message || 'Something went wrong');
    }
  };

  return (
    <div className="max-w-lg mx-auto p-6 bg-white rounded shadow-md mt-10">
      <h2 className="text-2xl font-bold mb-4 text-orange-500">Add Client</h2>

      {successMessage && <div className="bg-green-100 text-green-800 px-4 py-2 rounded mb-4">{successMessage}</div>}
      {errorMessage && <div className="bg-red-100 text-red-800 px-4 py-2 rounded mb-4">{errorMessage}</div>}

      <form onSubmit={handleSubmit} className="space-y-4">
      <input
          type="text"
          name="name"
          placeholder="Client Name"
          value={formData.name}
          onChange={handleInputChange}
          required
          className="w-full border px-4 py-2 rounded"
        />
        <input
          type="text"
          name="userId"
          placeholder="User Id"
          value={formData.userId}
          onChange={handleInputChange}
          className="w-full border px-4 py-2 rounded"
          required
        />

        <input
          type="text"
          name="referredBy"
          list="employeeSuggestions"
          placeholder="Guarantee (Enter or Select)"
          value={formData.referredBy}
          onChange={handleInputChange}
          className="w-full border px-4 py-2 rounded"
        />
        <datalist id="employeeSuggestions">
          {allEmployees.map((emp) => (
            <option key={emp._id} value={emp.userId} />
          ))}
        </datalist>

        <button
          onClick={() => navigate('/add-employee')}
          className="mb-4 bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded"
        >
          ➕ Add Guarantee
        </button>

        <Select
          options={brokerOptions}
          placeholder="Select Broker"
          isClearable
          value={brokerOptions.find(opt => opt.value === formData.brokerReferrel) || null}
          onChange={handleSelectChange}
        />

        <input
          type="number"
          name="commissionRate"
          placeholder="Commission Rate (%)"
          value={formData.commissionRate}
          onChange={handleInputChange}
          className="w-full border px-4 py-2 rounded"
        />

        <input
          type="number"
          name="idPercentage"
          placeholder="Id Percentage"
          value={formData.idPercentage}
          onChange={handleInputChange}
          className="w-full border px-4 py-2 rounded"
        />

        <button
          type="submit"
          className="w-full bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded"
        >
          Create Client
        </button>
      </form>
    </div>
  );
};

export default AddClient;
